module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "bootstrap-switch",
    attrs: {
      "type": "checkbox",
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271c290c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/InputToggle.vue
// module id = 841
// module chunks = 1